import React from 'react'
import { Button } from 'antd-mobile'
import { FormattedMessage } from 'react-intl'

import styles from '../PriceList/PriceList.module.css'

const CheckoutCounter = ({ toCheckout, disabled, amount, total }) => {
  return (
    <div className={styles.checkout}>
      <div className={styles.price}>
        <div className={styles.checkout}>
          <span>
            <FormattedMessage id="book-total" />
            {total}
          </span>
        </div>
      </div>
      <div className={styles.pay}>
        <Button type="primary" className={styles.payBtn} disabled={disabled} onClick={toCheckout}>
          <FormattedMessage id="book-checkout" />({amount})
        </Button>
        )
      </div>
    </div>
  )
}

export default CheckoutCounter
